<template>
  <roe-error-message :field="design.employer_match_true_up">
    <roe-radio-input
      v-model="design.$model.employer_match_true_up"
      value1="yes"
      value2="no"
      @change="resetAttributes(design, 'employer_match_true_up')"
    ></roe-radio-input>
  </roe-error-message>
</template>

<script>
import RoeErrorMessage from "@/components/_shared/inputs/ErrorMessage";
import RoeRadioInput from "@/components/_shared/inputs/RadioInput";
import ResetDesignAttributesMixin from "@/components/_shared/inputs/design/_mixins/ResetDesignAttributesMixin";
export default {
  name: "RoeEmployerMatchTrueUpCalculateRadio",
  components: { RoeRadioInput, RoeErrorMessage },
  mixins: [ResetDesignAttributesMixin],
  props: {
    design: Object
  }
};
</script>
